module.exports = __webpack_public_path__ + "img/notes.c1d60dd2.jpeg";